define(function (require, exports, module) {
    'use strict';
    var config = require('Cloud/config');

    var IS_MY_TEAM = config.get('IS_MY_TEAM');
    var UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     */
    function OverQuotaFail(stack, source) {
        UploadFail.apply(this, arguments);
    }

    OverQuotaFail.WEB_BACKEND_ERROR = 'overquota';

    OverQuotaFail.prototype = Object.assign(Object.create(UploadFail.prototype), {
        constructor: OverQuotaFail,
        className: 'OverQuotaFail',
        radarName: 'fail_{SOURCE}_overquota',
        message: [
            'В Облаке недостаточно места.',
            `${
                !IS_MY_TEAM
                    ? '<a href="https://help.mail.ru/cloud_web/size/increase" rel="noopener" target="_blank">Увеличить объем</a>'
                    : ''
            }`,
        ].join(' '),
    });

    module.exports = OverQuotaFail;
});
